export default __webpack_public_path__ + "static/media/purple.93759707.svg";